import i18n from '@/i18n/index'
import constant from '@/utils/constant.js'

export default {
  formData: [{
    title: i18n.t('form.store.generalInformation'),
    name: 0,
    createDateItem: [{
      span: 8,
      prop: 'purchase_order_id',
      name: 'select',
      options: [],
      label: i18n.t('form.purchase.purchaseOrder'),
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        disabled: false,
        value: 'id',
        key: 'id',
        filterable: true,
        nextChange: true,
        nextChangeProp: 'purchase_order_id',
        nextChangeClear: true,
        nextChangeClearProp: 'return_order_items_attributes',
        rules: [
          { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.itemStock') }) }
        ],
        maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
      }
    }, {
      span: 17,
      prop: 'remarks',
      name: 'input',
      type: 'textarea',
      label: i18n.t('form.purchase.remark'),
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
        maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
      }
    }]
  },
  {
    title: i18n.t('form.purchase.itemList'),
    name: 1,
    createDateItem: [{
      span: 24,
      prop: 'return_order_items_attributes',
      name: 'array',
      value: [],
      label: i18n.t('form.purchase.itemList'),
      Object: {
        rules: [
          { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.itemList') }) }
        ],
        delete: '_destroy',
        'array-label-width': '100px'
      },
      createDateFirstItem: [{
        span: 8,
        prop: 'shop_item_stock_id',
        name: 'select',
        options: [],
        value: [],
        label: i18n.t('form.purchase.itemStock'),
        placeholder: i18n.t('placeholder.defaultSelect'),
        Object: {
          value: 'id',
          key: 'id',
          nextChange: true,
          nextChangeProp: 'shop_item_stock_id',
          filterable: true,
          rules: [
            { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.itemStock') }) }
          ],
          maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
        }
      }, {
        span: 8,
        prop: 'quantity',
        name: 'input',
        type: 'number',
        label: i18n.t('form.purchase.quantity'),
        placeholder: i18n.t('placeholder.defaultInput'),
        Object: {
          rules: [
            { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.quantity') }) }
          ],
          maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
        }
      }, {
        span: 8,
        prop: 'return_reason',
        name: 'input',
        label: i18n.t('form.purchase.reason'),
        placeholder: i18n.t('placeholder.defaultInput'),
        Object: {
          maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
        }
      }]
    }]
  }]
}
